import React from 'react';
const results: {
  image: string;
  description: string;
  credit?: string;
  layout?: 'vertical';
}[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/4JWiKjGUeSXoWGtmKUKweM/Halo_Skin_Resurfacing3_.jpg',
  description: 'Treated for redness, rosacea, and uneven skin tone.',
  credit: 'Courtesy of Diane Duncan, MD, FACS'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8fP55Syc56PnyaDAXeeE5Z/Halo_1.jpg',
  description: 'Treated for fine lines, wrinkles, and skin texture.',
  layout: 'vertical'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/vKkiTe9fDjzsSi9GLERB8S/Halo_Skin_Resurfacing2.jpg',
  description: 'Treated for acne scarring and skin texture.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8ss5ta6u3nsqDbVd4Rq1J8/Halo_2.jpg',
  description: 'Treated for enlarged pores and uneven skin texture.',
  layout: 'vertical'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5TZ7zQSqE9JXPsMNMxP62Q/Halo_Skin_Resurfacing0.jpg',
  description: 'Treated for sun damage, freckles, and pigmentation.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/bVbzsHrWmPiyrTSv1NEep9/Halo_3.jpg',
  description: 'Treated for melasma, scarring, and hyperpigmentation.',
  layout: 'vertical'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/w49kDgZs6pT5sXdZKm8V2h/Halo_Skin_Resurfacing1.jpg',
  description: 'Treated for sun spots, hyperpigmentation, and age spots.'
}];
interface BeforeAfterSectionProps {
  onBookConsultation?: () => void;
}
export function BeforeAfterSection({
  onBookConsultation
}: BeforeAfterSectionProps) {
  return <section className="py-24 md:py-32 bg-muted" data-id="element-1">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-4" data-id="element-4">
            Real Results
          </h2>
          <p className="text-foreground/60 font-sans uppercase tracking-widest text-sm" data-id="element-5">
            Unretouched Patient Photos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10" data-id="element-6">
          {results.map((result, index) => <div key={index} className="group" data-id="element-7">
              <div className="relative overflow-hidden rounded-sm" data-id="element-8">
                <img src={result.image} alt={`Before and after: ${result.description}`} className="w-full h-auto object-cover" data-id="element-9" />
                <div className={`absolute ${result.layout === 'vertical' ? 'bottom-[calc(50%+6px)] right-3' : 'top-3 left-3'} bg-[#1E2A4A] px-3 py-1.5 text-[10px] font-sans uppercase tracking-widest text-white`} data-id="element-10">
                  Before
                </div>
                <div className={`absolute ${result.layout === 'vertical' ? 'bottom-3 right-3' : 'top-3 right-3'} bg-gold text-white px-3 py-1.5 text-[10px] font-sans uppercase tracking-widest`} data-id="element-11">
                  After
                </div>
              </div>
              <div className="mt-3 px-1" data-id="element-12">
                <p className="text-foreground/80 font-sans italic text-sm" data-id="element-13">
                  {result.description}
                </p>
                {result.credit && <p className="text-foreground/50 font-sans text-xs mt-1" data-id="element-14">
                    {result.credit}
                  </p>}
              </div>
            </div>)}
        </div>

        <div className="text-center flex flex-col items-center" data-id="element-15">
          <p className="text-foreground/50 font-sans text-xs max-w-2xl" data-id="element-16">
            *Results may vary. Photos are for illustrative purposes only and do
            not constitute a guarantee of results.
          </p>
        </div>

        {/* Opt-in CTA */}
        <div className="mt-16 bg-background border border-divider rounded-sm p-8 md:p-12 max-w-2xl mx-auto text-center" data-id="element-17">
          <h3 className="text-2xl md:text-3xl font-serif text-foreground mb-3" data-id="element-18">
            Want Results Like These?
          </h3>
          <p className="text-foreground/60 font-sans text-sm mb-8" data-id="element-19">
            Book a free consultation to see if Halo is right for your skin.
          </p>
          <button onClick={onBookConsultation} className="px-8 py-4 bg-gold text-white font-sans text-sm uppercase tracking-widest hover:bg-gold/90 transition-colors" data-id="element-20">
            Book A Consultation
          </button>
        </div>
      </div>
    </section>;
}